// extracted by mini-css-extract-plugin
export default {"svg":"CircularProgress_svg__CGk0o","rotate":"CircularProgress_rotate__CoeeB","circle":"CircularProgress_circle__YHB9h","dash":"CircularProgress_dash__i8uRp"};